import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErzeugungsanlageListComponent } from './erzeugungsanlage-list/erzeugungsanlage-list.component';
import { ErzeugungsanlagePageComponent } from './erzeugungsanlage-page/erzeugungsanlage-page.component';
import { MaterialModule } from '../common/material/material.module';
import { ServiceModule } from '../service/service.module';
import { ErzeugungsanlageRoutingModule } from './erzeugungsanlage-routing.module';
import { ErzeugungsanlageTileComponent } from './erzeugungsanlage-tile/erzeugungsanlage-tile.component';
import { ErzeugungsanlageDetailComponent } from './erzeugungsanlage-detail/erzeugungsanlage-detail.component';
import { ErzeugungsanlageTableComponent } from './erzeugungsanlage-table/erzeugungsanlage-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErzeugungsanlageTileViewComponent } from './erzeugungsanlage-tile-view/erzeugungsanlage-tile-view.component';
import { AbregelbareLeistungLowerEqualsInstallierteValidatorDirective } from './directives/abregelbare-leistung-lower-equals-installierte-validator.directive';
import { ResetAbregelbareLeistungErrorWhenInstallierteChangedValidatorDirective } from './directives/reset-abregelbare-leistung-error-when-installierte-changed-validator.directive';
import { GlobalDirectivesModule } from '../common/formvalidation/global-directives.module';
import { ErzeugungsanlageFilterComponent } from './erzeugungsanlage-filter/erzeugungsanlage-filter.component';
import { NetzzuordnungFormComponent } from './netzzuordnung-form/netzzuordnung-form.component';
import { ErzeugungsanlageDetailSummenerzeugerComponent } from './erzeugungsanlage-detail-summenerzeuger/erzeugungsanlage-detail-summenerzeuger.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        ServiceModule,
        ErzeugungsanlageRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        GlobalDirectivesModule,
    ],
    declarations: [
        ErzeugungsanlageListComponent,
        ErzeugungsanlageTileViewComponent,
        ErzeugungsanlagePageComponent,
        ErzeugungsanlageTileComponent,
        ErzeugungsanlageDetailComponent,
        ErzeugungsanlageDetailSummenerzeugerComponent,
        ErzeugungsanlageTableComponent,
        AbregelbareLeistungLowerEqualsInstallierteValidatorDirective,
        ResetAbregelbareLeistungErrorWhenInstallierteChangedValidatorDirective,
        ErzeugungsanlageFilterComponent,
        NetzzuordnungFormComponent,
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class ErzeugungsanlageModule {
}
